import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 53CE3621-DBCC-45E8-B105-2BEA7493CCA0
 * name email-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-outline.svg
 * tags
 */
export const EmailOutlineIcon = createSvgIcon(<><path d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6M20 6L12 11L4 6H20M20 18H4V8L12 13L20 8V18Z" /></>, 'EmailOutlineIcon');
export default EmailOutlineIcon